(function () {
  app.controller("YourRoomCtrl", [
    "$scope",
    "$timeout",
    function ($scope, $timeout) {
      $scope.init = function () {};

      $scope.showConfirmationStepPopup = function () {
        let params = {
          invitation_action: $scope.invitation_action,
          room_member_id: $scope.room_member_id,
        };
        $.get(`/rooms/confirmation_step`, params, function (rs) {});
      };

      $scope.onReady = function() {
        if ($scope.require_emergency_contact) {
          $.get($scope.change_emergency_contacts_user_path, function (rs) {});
        }
      };
    },
  ]);
}.call(this));
